module.exports = __webpack_public_path__ + "static/media/b1.dbb4c289.png";